"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PEVersion = exports.ProofPurpose = exports.ProofType = void 0;
var ProofType;
(function (ProofType) {
    ProofType["Ed25519Signature2018"] = "Ed25519Signature2018";
    ProofType["Ed25519Signature2020"] = "Ed25519Signature2020";
    ProofType["EcdsaSecp256k1Signature2019"] = "EcdsaSecp256k1Signature2019";
    ProofType["EcdsaSecp256k1RecoverySignature2020"] = "EcdsaSecp256k1RecoverySignature2020";
    ProofType["JsonWebSignature2020"] = "JsonWebSignature2020";
    ProofType["RsaSignature2018"] = "RsaSignature2018";
    ProofType["GpgSignature2020"] = "GpgSignature2020";
    ProofType["JcsEd25519Signature2020"] = "JcsEd25519Signature2020";
    ProofType["BbsBlsSignatureProof2020"] = "BbsBlsSignatureProof2020";
    ProofType["BbsBlsBoundSignatureProof2020"] = "BbsBlsBoundSignatureProof2020";
})(ProofType = exports.ProofType || (exports.ProofType = {}));
var ProofPurpose;
(function (ProofPurpose) {
    ProofPurpose["assertionMethod"] = "assertionMethod";
    ProofPurpose["authentication"] = "authentication";
    ProofPurpose["keyAgreement"] = "keyAgreement";
    ProofPurpose["contractAgreement"] = "contactAgreement";
    ProofPurpose["capabilityInvocation"] = "capabilityInvocation";
    ProofPurpose["capabilityDelegation"] = "capabilityDelegation";
})(ProofPurpose = exports.ProofPurpose || (exports.ProofPurpose = {}));
var PEVersion;
(function (PEVersion) {
    PEVersion["v1"] = "v1";
    PEVersion["v2"] = "v2";
})(PEVersion = exports.PEVersion || (exports.PEVersion = {}));
